(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.jpeInit === '1') return;
    root.dataset.jpeInit = '1';

    var roadmap = root.querySelector('[data-jpe-roadmap]');
    var track = root.querySelector('[data-jpe-list]');
    var holder = root.querySelector('[data-jpe-panel-holder]');
    var panel = root.querySelector('[data-jpe-panel]');
    if (!roadmap || !track || !holder || !panel) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-jpe-item]'));
    var triggers = Array.prototype.slice.call(track.querySelectorAll('[data-jpe-trigger]'));
    var prevBtn = roadmap.querySelector('[data-jpe-prev]');
    var nextBtn = roadmap.querySelector('[data-jpe-next]');
    var closeBtn = panel.querySelector('[data-jpe-close]');
    var nextStepBtn = panel.querySelector('[data-jpe-next-step]');
    var panelMedia = panel.querySelector('[data-jpe-panel-media]');
    var panelNum = panel.querySelector('[data-jpe-panel-num]');
    var panelPlace = panel.querySelector('[data-jpe-panel-place]');
    var panelTitle = panel.querySelector('[data-jpe-panel-title]');
    var panelText = panel.querySelector('[data-jpe-panel-text]');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var activeButton = null;
    var closeTimer = null;
    var ensureTimer = null;

    function scrollBehavior() {
      return reduceMotion.matches ? 'auto' : 'smooth';
    }

    function trackScrollTo(left) {
      var max = track.scrollWidth - track.clientWidth;
      var target = Math.max(0, Math.min(left, max));
      try {
        track.scrollTo({ left: target, behavior: scrollBehavior() });
      } catch (err) {
        track.scrollLeft = target;
      }
    }

    function slideStep() {
      if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
      return items.length ? items[0].offsetWidth : 0;
    }

    function scrollToItem(item) {
      var pad = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
      trackScrollTo(item.offsetLeft - pad);
    }

    function stripIds(container) {
      var withId = container.querySelectorAll('[id]');
      for (var i = 0; i < withId.length; i++) {
        withId[i].removeAttribute('id');
      }
    }

    function fillPanel(item, index) {
      var content = item.querySelector('[data-jpe-content]');
      if (!content) return false;
      var title = content.querySelector('[data-jpe-title]');
      var place = content.querySelector('[data-jpe-place]');
      var text = content.querySelector('[data-jpe-text]');
      var media = content.querySelector('[data-jpe-media]');
      panelNum.textContent = index;
      panelTitle.textContent = title ? title.textContent : '';
      var placeValue = place ? place.textContent.trim() : '';
      panelPlace.textContent = placeValue;
      panelPlace.hidden = placeValue === '';
      panelText.innerHTML = text ? text.innerHTML : '';
      panelMedia.innerHTML = media ? media.innerHTML : '';
      panel.classList.toggle('jpe-panel--no-media', !panelMedia.firstElementChild);
      stripIds(panelText);
      stripIds(panelMedia);
      return true;
    }

    function ensureVisible() {
      var rect = panel.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < 0 || rect.bottom > vh) {
        panel.scrollIntoView({ block: 'nearest', behavior: scrollBehavior() });
      }
    }

    function deactivate(btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('jpe-is-active');
    }

    function openFor(btn, initial) {
      var item = btn.closest('[data-jpe-item]');
      if (!item) return;
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (ensureTimer) {
        window.clearTimeout(ensureTimer);
        ensureTimer = null;
      }
      if (activeButton && activeButton !== btn) {
        deactivate(activeButton);
        activeButton = null;
      }
      if (!fillPanel(item, btn.getAttribute('data-jpe-index'))) return;
      activeButton = btn;
      btn.setAttribute('aria-expanded', 'true');
      btn.classList.add('jpe-is-active');
      if (nextStepBtn) {
        var stepIdx = triggers.indexOf(btn);
        var hasNext = stepIdx > -1 && stepIdx + 1 < triggers.length;
        var ctaFocused = document.activeElement === nextStepBtn;
        nextStepBtn.hidden = !hasNext;
        if (!hasNext && ctaFocused && closeBtn) closeBtn.focus();
      }
      if (initial || reduceMotion.matches) {
        holder.hidden = false;
        panel.classList.add('jpe-is-open');
        if (!initial) ensureVisible();
      } else {
        panel.classList.remove('jpe-is-open');
        holder.hidden = false;
        void panel.offsetHeight;
        panel.classList.add('jpe-is-open');
        ensureTimer = window.setTimeout(function () {
          ensureTimer = null;
          ensureVisible();
        }, 430);
      }
      if (!initial) scrollToItem(item);
    }

    function close(returnFocus) {
      if (!activeButton) return;
      if (ensureTimer) {
        window.clearTimeout(ensureTimer);
        ensureTimer = null;
      }
      var btn = activeButton;
      activeButton = null;
      deactivate(btn);
      panel.classList.remove('jpe-is-open');
      if (reduceMotion.matches) {
        holder.hidden = true;
      } else {
        closeTimer = window.setTimeout(function () {
          holder.hidden = true;
          closeTimer = null;
        }, 430);
      }
      if (returnFocus) btn.focus();
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (activeButton === btn) {
          close(false);
        } else {
          openFor(btn, false);
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }

    if (nextStepBtn) {
      nextStepBtn.addEventListener('click', function () {
        if (!activeButton) return;
        var idx = triggers.indexOf(activeButton);
        if (idx > -1 && idx + 1 < triggers.length) {
          openFor(triggers[idx + 1], false);
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        trackScrollTo(track.scrollLeft - slideStep());
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        trackScrollTo(track.scrollLeft + slideStep());
      });
    }

    var supportsIO = 'IntersectionObserver' in window;

    if (supportsIO && !reduceMotion.matches && items.length) {
      track.classList.add('jpe-anim-init');
      var revealIO = new IntersectionObserver(function (entries, obs) {
        var delay = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.transitionDelay = delay + 'ms';
          entry.target.classList.add('jpe-revealed');
          obs.unobserve(entry.target);
          delay += 60;
        });
      }, { threshold: 0.15 });
      items.forEach(function (item) {
        revealIO.observe(item);
      });
    }

    if (supportsIO && items.length && prevBtn && nextBtn) {
      var first = items[0];
      var last = items[items.length - 1];
      var edgeIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var atEdge = entry.intersectionRatio >= 0.9;
          if (entry.target === first) prevBtn.disabled = atEdge;
          if (entry.target === last) nextBtn.disabled = atEdge;
        });
      }, { root: track, threshold: [0, 0.9] });
      edgeIO.observe(first);
      edgeIO.observe(last);
    }

    var onKeydown = function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!root.isConnected || !activeButton) return;
      close(true);
    };
    document.addEventListener('keydown', onKeydown);

    var onBlockSelect = function (event) {
      if (!root.isConnected || !root.contains(event.target)) return;
      var btn = event.target.querySelector('[data-jpe-trigger]');
      if (btn && activeButton !== btn) openFor(btn, false);
    };
    document.addEventListener('shopify:block:select', onBlockSelect);

    var onSectionUnload = function (event) {
      if (!event.target.contains(root) && event.target !== root) return;
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    };
    document.addEventListener('shopify:section:unload', onSectionUnload);

    if (triggers.length) {
      openFor(triggers[0], true);
    }
  }

  function initAll(context) {
    var roots = (context || document).querySelectorAll('[data-jpe-root]');
    Array.prototype.forEach.call(roots, initSection);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
